import { render, staticRenderFns } from "./ChatAdmin.vue?vue&type=template&id=0e74f61c&scoped=true&"
import script from "./ChatAdmin.vue?vue&type=script&lang=js&"
export * from "./ChatAdmin.vue?vue&type=script&lang=js&"
import style1 from "./ChatAdmin.vue?vue&type=style&index=1&id=0e74f61c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e74f61c",
  null
  
)

export default component.exports